
import referral from './referral.json';
import content from './content.json';
import following from './following.json';

export default {
  description: "Connect with the community and share your experiences",
  referral,
  content,
  following
};
